export enum OfferTypeEnum {
	NGA = 'NGA',
	GA = 'GA'
}